<template>
  <v-col
    v-if="enabled"
    :cols="cols"
    :lg="lg"
    :md="md"
  >
    <v-row dense>
      <v-col
        class="labeled-input"
        cols="12"
      >
        <span>{{ $bct(label) }}</span>
      </v-col>
      <template v-if="description">
        <v-col
          class="fs-16 c-light-black my-1"
          cols="12"
        >
          <span>{{ $bct(description) }}</span>
        </v-col>
      </template>
      <v-col>
        <v-combobox
          @blur="handleBlur"
          @update:model-value="handleUpdateModelValue"
          :append-inner-icon="appendIcon"
          :aria-label="ariaLabel"
          :chips="chips"
          :closable-chips="deletableChips"
          :density="dense || veryDense ? 'compact' : undefined"
          :disabled="locked"
          :model-value="localValue"
          :multiple="multiple"
          variant="filled"
          data-cy
          hide-details
          tile
          v-bind="filteredAttrs"
        />
      </v-col>
    </v-row>
  </v-col>
</template>

<script setup>
import { onUpdated } from 'vue';
import useLabeledField from '@/shared/composables/useLabeledField';
import useSchematizedField from '@/shared/composables/useSchematizedField';
import attrsOmitDataPrefix from '@/shared/utils/filteredAttrs';
import propsToRefs from '@/shared/utils/propsToRefs';

const emit = defineEmits(useLabeledField.emits);
defineExpose({ emit }); // Emit is used in composable, this is included for linter

const $bct = inject('translator');

const localValue = defineModel({ type: [String, Array] });

const props = defineProps({
  chips: Boolean,
  description: {
    type: String,
    default: null,
  },
  deletableChips: Boolean,
  multiple: Boolean,
  ...useLabeledField.props,
  ...useSchematizedField.props,
});

const { appendIcon, handleBlur, handleUpdateModelValue } = useLabeledField(
  ...propsToRefs(props, useLabeledField.paramKeys),
);

const { ariaLabel, enabled, label, locked } = useSchematizedField(
  ...propsToRefs(props, useSchematizedField.paramKeys),
);

const attrs = useAttrs();
const filteredAttrs = ref(attrsOmitDataPrefix(attrs));

onUpdated(() => {
  filteredAttrs.value = attrsOmitDataPrefix(attrs);
});
</script>
